module.exports = __webpack_public_path__ + "img/whatsapp-settings.a1d69c15.svg";